import { eq } from 'tio-ui/utilities';
import { get } from '@ember/object';
import { hash } from '@ember/helper';
import { on } from '@ember/modifier';
import { PhCurrencyCircleDollar } from 'ember-phosphor-icons';
import { Popover } from 'tio-ui/components/popover';
import { t } from 'ember-intl';
import type { TOC } from '@ember/component/template-only';

export interface ReimbursementTagSignature {
  Args: {
    size?: 'sm' | 'md' | 'lg';
    disablePopover?: boolean;
  };
  Element: HTMLDivElement;
}

const ReimbursementPopoverTag: TOC<ReimbursementTagSignature> = <template>
  <div
    class="flex gap-1 items-center text-tio-gray-700
      {{if (eq @size 'sm') 'text-sm' (if (eq @size 'lg') 'text-lg' 'text-base')}}"
    ...attributes
  >
    <PhCurrencyCircleDollar
      @size={{get (hash sm=16 md=20 lg=24) (if @size @size "md")}}
      class="text-tio-gray-700 flex-none"
    />

    {{#if @disablePopover}}
      <span class="text-tio-gray-700">
        {{t "tuition_assistance.limits_summary.reimbursement"}}
      </span>
    {{else}}
      <Popover as |pop|>
        <button
          type="button"
          {{pop.trigger}}
          {{pop.anchor}}
          {{on "mouseenter" pop.open}}
          {{on "mouseleave" pop.close}}
          class="self-start"
        >
          <span class="underline underline-offset-4 decoration-1 text-tio-gray-700">
            {{t "tuition_assistance.limits_summary.reimbursement"}}
          </span>
        </button>
        <pop.Content
          @preventAutoFocus={{true}}
          @preventFocusRestore={{true}}
          @renderInPlace={{true}}
          @size="lg"
          @class="p-2 flex flex-col gap-y-2 text-tio-gray-700 text-base/7"
        >
          <span class="font-semibold">{{t "tuition_assistance.limits_summary.reimbursement"}}</span>
          <p class="leading-6">{{t "tuition_assistance.limits_summary.reimbursement_body"}}</p>
        </pop.Content>
      </Popover>
    {{/if}}
  </div>
</template>;

export default ReimbursementPopoverTag;
